import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import VueLogger from 'vuejs-logger'
import { i18n } from '@/i18n'
import dayjs from 'dayjs'

// amplify configuration
import { Amplify } from 'aws-amplify'
import { awsExportsDev, awsExportsStg, awsExportsProd, awsExportsMobileAppDev, awsExportsMobileAppStg, awsExportsMobileAppProd } from '@/aws-exports'

if (process.env.VUE_APP_DISP_STAGE_NAME === 'prod') {
  if (store.getters.getIsMobileApp) {
    Amplify.configure(awsExportsMobileAppProd)
  } else {
    Amplify.configure(awsExportsProd)
  }
} else if (process.env.VUE_APP_DISP_STAGE_NAME === 'stg') {
  if (store.getters.getIsMobileApp) {
    Amplify.configure(awsExportsMobileAppStg)
  } else {
    Amplify.configure(awsExportsStg)
  }
} else {
  if (store.getters.getIsMobileApp) {
    Amplify.configure(awsExportsMobileAppDev)
  } else {
    Amplify.configure(awsExportsDev)
  }
}
// Logger
const isProduction = process.env.NODE_ENV === 'production'
const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}
Vue.use(VueLogger, options)

// フィルター
Vue.filter('formatDate', function (value) {
  if (value) {
    return dayjs.unix(value).format('YYYY/MM/DD')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return dayjs.unix(value).format('YYYY/MM/DD HH:mm:ss')
  }
})

Vue.config.productionTip = false
const vm = new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
export default vm
